module.exports = __webpack_public_path__ + "img/responsive hospitium-08.f5b8e9a8.jpg";